import {
  alpha,
  IconButton,
  Pagination,
  styled,
  TableCell,
  TableRow,
} from '@mui/material';

import { StyledInputBase } from '../../styles';

export const SearchInput = styled(StyledInputBase)(({ theme }) => ({
  '& .MuiInputAdornment-positionStart': {
    color: theme.palette.secondary.main,
  },
  '&.Mui-disabled': {
    borderColor: alpha(theme.palette.common.grey, 0.4),
    '& .MuiInputAdornment-positionStart': {
      color: alpha(theme.palette.common.grey, 0.4),
    },
  },
}));

export const ClearSearchButton = styled(IconButton)(({ theme }) => ({
  padding: '4px',
  '& span': {
    fontSize: '20px',
    color: theme.palette.secondary.main,
  },
}));

export const TableCellHeader = styled(TableCell)(({ theme }) => ({
  color: theme.palette.secondary.main,
  font: '600 21px Montserrat',
  backgroundColor: '#F1F5FA',
  verticalAlign: 'middle',
  padding: '20px 16px',
  '& span': {
    verticalAlign: 'bottom',
    paddingLeft: '4px',
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '16px',
    '& span': {
      fontSize: '18px',
    },
  },
}));

export const StyledCell = styled(TableCell)(({ theme }) => ({
  color: '#707070',
  fontSize: '15px',
  [theme.breakpoints.up('xl')]: {
    padding: '20px',
    fontSize: '16px',
  },
}));

export const StyledRow = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:nth-of-type(even)': {
    backgroundColor: '#F1F5FA66',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.grey, 0.2),
  },
}));

export const StyledPagination = styled(Pagination)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  margin: '8px',
  width: '100%',
}));
